import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { ValidationImageService } from 'src/app/services/validation-images-service/validation-image.service';
import { MatDialogRef } from '@angular/material/dialog';
import { MediaGalleryItem } from '../media-gallery-item/media-gallery-item.model';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { flatMap } from 'rxjs/operators';

@Component({
  selector: 'app-media-gallery-add-image-dialog',
  templateUrl: './media-gallery-add-image-dialog.component.html',
  styleUrls: ['./media-gallery-add-image-dialog.component.scss']
})
export class MediaGalleryAddImageDialogComponent implements OnInit {

  @ViewChild('uploadInput', { static: false }) uploadInput: ElementRef;
  images: Array<MediaGalleryItem>;
  url: string;
  errorMessage: string;
  invalid: boolean;

  constructor(public dialogRef: MatDialogRef<MediaGalleryAddImageDialogComponent>,
              private validationImageService: ValidationImageService,
              private snackbarService: SnackBarService) {
                this.dialogRef.disableClose = true;
                this.images = new Array<MediaGalleryItem>();
    }

  ngOnInit() {
  }

  public accept() {
    if (this.validateForm()) {
      if (!(this.images.length > 0) && this.url) {
        this.images.push(new MediaGalleryItem(null, this.url, 'IMAGE_URL', this.url, this.url, false, null, 60, null, null));
      }
      this.dialogRef.close(this.images);
    } else {
      return false;
    }
  }

  public cancel() {
    this.dialogRef.close();
  }

  public validateForm() {
    if ((this.images.length > 0) && !this.url) {
      return true;
    } else if (!(this.images.length > 0) && this.url) {
      return true;
    }
    return false;
  }

  public uploadPhotoClicker() {
    this.uploadInput.nativeElement.value = null;
    this.uploadInput.nativeElement.click();
  }

  public uploadAsset(event) {
    const files = event.target.files;
    if (files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        this.validationImageService.toBase64(files[i])
        .pipe(
          flatMap(
            file => this.validationImageService.validateImageMIMEType(file)
          )
        )
        .subscribe(
          (base64) => {
            this.invalid = false;
            this.errorMessage = null;
            const image = new MediaGalleryItem(null, this.uploadInput.nativeElement.files[i].name, 'IMAGE_FILE', base64, base64, false, null, 60, null, null);
            this.images.push(image);
          },
          (error) => {
            this.invalid = true;
            this.errorMessage = null;
            this.errorMessage = error;
          }
        );
      }
    }
  }
}
